export default "__VITE_ASSET__CQdTjDHf__"